export function formatPriceRON(value: number | string | null | undefined): string {
    if (value == null || value === '') return '—';
    const n = typeof value === 'string' ? Number(value) : value;
    if (!Number.isFinite(n)) return '—';
    return `${n.toFixed(2)} RON`;
}

export function formatNumber(value: number | string | null | undefined): string {
    if (value == null || value === '') return '—';
    const n = typeof value === 'string' ? Number(value) : value;
    if (!Number.isFinite(n)) return '—';
    return n.toLocaleString('ro-RO');
}

// Date-only in Romanian locale, e.g. "11 iun. 2026". Returns "—" for
// null/unparseable input.
export function formatDateRO(iso?: string | null): string {
    if (!iso) return '—';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('ro-RO', { day: '2-digit', month: 'short', year: 'numeric' });
}

// Date + time in Romanian locale, e.g. "11 iun. 2026, 14:30".
export function formatDateTimeRO(iso?: string | null): string {
    if (!iso) return '—';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleString('ro-RO', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

// Romanian plural rules:
//   1            → singular         ("1 produs")
//   2..19        → bare plural      ("3 produse")
//   0, 20+, ≥100 → "de" + plural    ("0 de produse", "20 de produse")
// Negative counts are treated as positive for grammar purposes.
export function pluralRO(count: number, singular: string, plural: string): string {
    const n = Math.abs(Math.trunc(count));
    if (n === 1) return `${count} ${singular}`;
    if (n >= 2 && n <= 19) return `${count} ${plural}`;
    return `${count} de ${plural}`;
}
